import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_93: FaireProductEntity = {
  token: "starter_collection_93",
  type: "product",
  name: "Magnetic Knife Storage",
  brandName: "Material",
  imageUrl:
    "https://cdn.faire.com/fastly/8be4356c47481fbe947b1e2946f9fe739e67917d45a61cecc07e6fd6b18babb7.png?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 85,
  msrpDollars: 170,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
